import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';
import BreakpointHelper from '../../00_utilities/helpers/BreakpointHelper';

class Navigation {
    constructor(elem) {
        this.elem = elem;
        this.breakpoints = {
            'main-navigation-breakpoint': 992,
        };
        this.mainToggle = document.getElementById('main-menu-toggle');
        this.layoutDesktop = BreakpointHelper.aboveBreakpoint(this.breakpoints['main-navigation-breakpoint']);
    }

    static ariaPressedHelper(element, state) {
        if (element) {
            element.setAttribute('aria-pressed', state);
        }
    }

    init() {
        this.behaviourOnChange();
        this.initFocusHandling();
        this.initResizeSensibleFunctions();
    }

    initResizeSensibleFunctions() {
        let aboveBreakpoint = BreakpointHelper.aboveBreakpoint(this.breakpoints['main-navigation-breakpoint']);

        window.addEventListener('resize', GeneralHelper.throttle(() => {
            const breakpointInfo = BreakpointHelper.breakpointCrossed(
                this.breakpoints['main-navigation-breakpoint'],
                aboveBreakpoint,
            );
            aboveBreakpoint = breakpointInfo.aboveBreakpoint;
            const { breakpointCrossed } = breakpointInfo;

            if (breakpointCrossed) {
                this.layoutDesktop = aboveBreakpoint;
                Navigation.closeNavigation();
                if (aboveBreakpoint) {
                    Navigation.allowScrolling();
                }
            }
        }, 200));
    }

    /**
     * prevent or allow scrolling on body in case
     * mobile navigation is open
     */
    behaviourOnChange() {
        const mainToggleHandling = (event) => {
            Navigation.ariaPressedHelper(this.mainToggle, this.mainToggle.checked);
            if (this.mainToggle.checked) {
                Navigation.preventScrolling();
                document.addEventListener('click', this.bodyClickListener);
                return;
            }

            this.closeChildren(event.currentTarget);
            Navigation.allowScrolling();
            document.removeEventListener('click', this.bodyClickListener);
        };

        this.mainToggle.addEventListener('change', mainToggleHandling, false);

        const toggleInputs = this.elem.querySelectorAll('.navigation__menu-toggle-input');
        for (const toggle of toggleInputs) {
            toggle.addEventListener('change', (event) => {
                const { currentTarget } = event;
                const { checked } = currentTarget;
                Navigation.ariaPressedHelper(currentTarget, checked);

                if (currentTarget.parentNode.classList.contains('navigation__item--main') && this.layoutDesktop) {
                    Navigation.checkboxHelper(this.mainToggle, checked, true);
                }

                if (checked) {
                    this.closeSiblings(currentTarget);
                    return;
                }

                this.closeChildren(currentTarget);
            });
        }
    }

    static preventScrolling(element = 'body') {
        window.requestAnimationFrame(() => {
            document.querySelector(element).classList.add('no-scroll');
        });
    }

    static allowScrolling(element = 'body') {
        window.requestAnimationFrame(() => {
            document.querySelector(element).classList.remove('no-scroll');
        });
    }

    static checkboxHelper(checkbox, check, triggerChange) {
        if (typeof checkbox.prop === 'undefined') {
            checkbox.checked = check;

            if (triggerChange) {
                const event = new Event('change');
                checkbox.dispatchEvent(event);
            }
            return;
        }
        checkbox
            .prop('checked', check)
            .attr('checked', check);
        if (triggerChange) {
            checkbox.trigger('change');
        }
    }

    getSiblings(element) {
        return Array.prototype.filter.call(element.parentNode.children, (sibling) => {
            return sibling !== element;
        });
    }

    closeSiblings(current) {
        let currentMenu = this.elem;

        if (current.id !== 'main-menu-toggle') {
            currentMenu = current.parentNode;
        }

        const menuSiblings = this.getSiblings(currentMenu);

        for (const sibling of menuSiblings) {
            const siblingsToggle = sibling.querySelector('.navigation__menu-toggle-input');
            if (siblingsToggle) {
                Navigation.checkboxHelper(siblingsToggle, false);
            }
        }
    }

    closeChildren(current) {
        let currentMenu = this.elem;

        if (current.id !== 'main-menu-toggle') {
            currentMenu = current.parentNode;
        }

        const menuChildren = currentMenu.querySelectorAll('.navigation__has-children');
        for (const sibling of menuChildren) {
            const siblingsToggle = sibling.querySelector('.navigation__menu-toggle-input');
            if (siblingsToggle) {
                Navigation.checkboxHelper(siblingsToggle, false);
            }
        }
    }

    static closeNavigation() {
        const mainToggle = document.getElementById('main-menu-toggle');
        Navigation.checkboxHelper(mainToggle, false, true);
    }

    initFocusHandling() {
        const focusableNavigationItems = this.elem.querySelectorAll(
            '.navigation__menu-toggle-input, .navigation__menu-item > a',
        );

        if (focusableNavigationItems.length) {
            for (const item of focusableNavigationItems) {
                item.addEventListener('keyup', (event) => {
                    if (event.which === 9) {
                        const { currentTarget } = event;
                        const parent = currentTarget.parentNode;

                        if (parent.classList.contains('navigation__item--main')) {
                            if (currentTarget.checked
                                && this.layoutDesktop) {
                                Navigation.closeNavigation();
                                return;
                            }
                            // Navigation.checkboxHelper(this.mainToggle, currentTarget.checked, true);
                            return;
                        }

                        if (parent.classList.contains('navigation__item')) {
                            if (currentTarget.checked) {
                                this.closeSiblings(currentTarget);
                            }
                            // return;
                        }

                        // Navigation.checkboxHelper(currentTarget, false, true);
                    }
                });
            }
        }
    }

    bodyClickListener(e) {
        const { target } = e;
        const isNavigation = target.closest('.navigation') !== null
            || document.querySelector('.navigation') === target
            || target.closest('.page-header') !== null
            || document.querySelector('.page-header') === target
            || document.querySelector('.menu-toggle-input') === target;

        if (!isNavigation) {
            Navigation.closeNavigation();
            Navigation.allowScrolling();
        }
    }
}

export default Navigation;
